import api, { transformRequest, transformResponse } from "services/api";

export const debtorAssetsApi = api
  .enhanceEndpoints({
    addTagTypes: [
      "DebtorAsset",
      "DebtorAssetCategoryDromoSchema",
      "DebtorAssetCustomFieldDromoSchema",
    ],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchDebtorAssets: build.query({
        query: ({ debtorId }) => `/api/v1/core/debtors/${debtorId}/assets/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? [
                ...results.map(({ id }) => ({ type: "DebtorAsset", id })),
                { type: "DebtorAsset", id: "LIST" },
              ]
            : [{ type: "DebtorAsset", id: "LIST" }],
      }),
      addDebtorAsset: build.mutation({
        query: ({ debtorId, ...payload }) => ({
          url: `/api/v1/core/debtors/${debtorId}/assets/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "DebtorAsset", id: "LIST" }],
      }),
      updateDebtorAsset: build.mutation({
        query: ({ debtorId, debtorAssetId, ...payload }) => ({
          url: `/api/v1/core/debtors/${debtorId}/assets/${debtorAssetId}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "DebtorAsset", id: "LIST" }],
      }),
      deleteDebtorAsset: build.mutation({
        query: ({ debtorId, debtorAssetId }) => ({
          url: `/api/v1/core/debtors/${debtorId}/assets/${debtorAssetId}/delete/`,
          method: "POST",
        }),
        invalidatesTags: [{ type: "DebtorAsset", id: "LIST" }],
      }),
      fetchDebtorAssetCategoriesDromoSchema: build.query({
        query: () => `/api/v1/core/debtor-asset-categories/dromo-schema/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: () => [{ type: "DebtorAssetCategoryDromoSchema", id: "LIST" }],
      }),
      fetchDebtorAssetCustomFieldsDromoSchema: build.query({
        query: () => `/api/v1/core/debtor-asset-custom-fields/dromo-schema/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: () => [{ type: "DebtorAssetCustomFieldDromoSchema", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useFetchDebtorAssetsQuery,
  useAddDebtorAssetMutation,
  useUpdateDebtorAssetMutation,
  useDeleteDebtorAssetMutation,
  useFetchDebtorAssetCategoriesDromoSchemaQuery,
  useFetchDebtorAssetCustomFieldsDromoSchemaQuery,
} = debtorAssetsApi;
